// extracted by mini-css-extract-plugin
module.exports = {"container":"RabbitType_container__4QdAs","typeLink":"RabbitType_typeLink__3hks0"};